export default function (value) {
  switch (value) {
    case '8':
      return 'Mild Hybrid/petrol/ethanol';
    case 'A':
      return 'Accumulator/Electric';
    case 'B':
      return 'Petrol';
    case 'C':
      return 'Full Hybrid/diesel';
    case 'D':
      return 'Diesel';
    case 'E':
      return 'Electric-hydrogen';
    case 'F':
      return 'Full Hybrid/petrol';
    case 'G':
      return 'CNG (with or without Petrol)';
    case 'H':
      return 'Full Hybrid/petrol/ethanol';
    case 'I':
      return 'Mild Hybrid/diesel';
    case 'J':
      return 'Mild Hybrid/petrol';
    case 'K':
      return 'Plug-in Hybrid/diesel';
    case 'L':
      return 'LPG (with or without Petrol)';
    case 'Q':
      return 'Plug-in Hybrid/diesel';
    case 'R':
      return 'Bio (ethanol) petrol or Methanol';
    case 'T':
      return 'Diesel with CNG prepared';
    case 'V':
      return 'Ethanol (with or without Diesel)';
    case 'W':
      return 'LNG';
    case 'Y':
      return 'Natural Gas (CNG/LNG)';
    case 'Z':
      return 'Range Extender/petrol';
    case 'X':
      return 'Hybrid';
    default:
      return value;
  }
}
